import { connect } from 'react-redux'

import MergeButtonView from 'components/ConversationHeader/Buttons/MergeButton'
import MergeDropdown from '../MergeDropdown'

const select = () => ({
  MergeDropdown,
})

export default connect(select)(MergeButtonView)
